import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { RuntimeConfigService } from '../../core/config/runtime-config.service';

export type LandingContactRequestPayload = {
  subject?: string;
  firstName: string;
  lastName: string;
  companyName: string;
  workEmail: string;
  phoneNumber: string;
  jobTitle: string;
  requestedPlans: Array<{
    planKey: string;
    planName: string;
    quantity: number;
  }>;
  message: string;
};

@Injectable({ providedIn: 'root' })
export class LandingContactService {
  private readonly http = inject(HttpClient);
  private readonly runtimeConfig = inject(RuntimeConfigService);

  private get apiBaseUrl(): string {
    return `${this.runtimeConfig.getConfig().backendBaseUrl}/api/contact`;
  }

  submitPricingRequest(payload: LandingContactRequestPayload): Observable<{ success: boolean; submittedAt: string }> {
    return this.http.post<{ success: boolean; submittedAt: string }>(this.apiBaseUrl, payload);
  }
}
